import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

export type TPopularUpcomingDates = {
  title: string;
  image: string;
  active_listing_count: number;
  booking_count: number;
  dates: {
    from: string;
    to: string;
  };
};

export const usePopularUpcomingDates = () => {
  const { data, error } = useSWR<TPopularUpcomingDates[]>(
    `${getCoreApi()}/widget/booked-dates`,
    url =>
      apiRequest({
        method: 'GET',
        url,
      }),
    {
      revalidateOnFocus: false,
    },
  );

  return { data, error };
};
